import {
  ClientDataType,
  Combinator,
  CompleteCondition,
  CompleteQuery,
} from 'modules/queryBuilder/types';

/**
 * A util to create a search query with the provided requirement dataType and conditions
 */
export const createSearchQueryWithSingleRequirement = (
  dataType: ClientDataType,
  conditions: CompleteCondition[],
): CompleteQuery => ({
  combinator: Combinator.AND,
  searchQueries: [
    {
      combinator: Combinator.AND,
      searchQueries: [
        {
          dataType,
          searchCombo: {
            combinator: Combinator.AND,
            searchQueries: conditions,
          },
        },
      ],
    },
  ],
});
